import { createListReducer } from 'app/redux/reducers/_reducer-factory/createListReducer';

const TEMPLATE_NAME = 'CRUD_PATIENTS';

export default createListReducer(TEMPLATE_NAME);
